import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/';
import { RedirectGuard } from './@core/guards/redirect.guard';
import { MenuRoles } from './@shared/menus/menu-roles';
import { LandingComponent, MainComponent } from './layouts';

const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./modules/landing/landing.module').then(m => m.LandingModule),
        canActivate: [RedirectGuard], // !! UYARI !! : RedirectGuard geçiçi olarak yapılmıştır. Angular'a geçildiğinde buradan silip RedirectGuard dosyası silinecektir.
      },
    ],
  },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'settings',
        loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [RedirectGuard, AuthGuard], // !! UYARI !! : RedirectGuard geçiçi olarak yapılmıştır. Angular'a geçildiğinde buradan silip RedirectGuard dosyası silinecektir.
      },
      {
        path: 'consumptionSummary',
        loadChildren: () => import('./modules/consumption-summary/consumption-summary.module').then(m => m.ConsumptionSummaryModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'notifications',
        loadChildren: () => import('./modules/notifications/notifications.module').then(m => m.NotificationsModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'meter-indices',
        loadChildren: () => import('./modules/meter-indices/meter-indices.module').then(m => m.MeterIndicesModule),
        canActivate: [AuthGuard],
      },
      {
        path: 'facilityReport',
        loadChildren: () => import('./modules/facility-report/facility-report.module').then(m => m.FacilityReportModule),
        canActivate: [AuthGuard],
        data: {
          roles: MenuRoles.FacilityReport
        }
      },
    ],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
